// src/index.tsx

// Must be imported before any React import so react-scan can patch the renderer
// in dev. See src/reactScanInit.ts. Kept first via a side-effect import (the
// import sorter would otherwise reorder a named react-scan import below React).
import '@/reactScanInit';
import '@styles/globals.css';
// Country-dropdown styles for react-phone-input-2. Imported globally here so the
// dropdown renders correctly anywhere a phone field is shown (e.g. the case
// summary/details output board), not only on the create-case pages that import
// it locally.
import 'react-phone-input-2/lib/style.css';

import App from '@app/App';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { initializeSentry } from '@/config/sentry';
import { initAnalytics } from '@/services/analytics';
import { suppressResizeObserverError } from '@/utils/suppressResizeObserverError';

// Initialize Sentry before rendering the app
initializeSentry();

// Initialize the frontend analytics SDK after Sentry, before rendering the app
initAnalytics();

// Stop the dev-overlay from intercepting the harmless ResizeObserver loop
// warning that Radix popovers (e.g. the Workforce Console reassign menu)
// occasionally emit when content reflows mid-paint.
suppressResizeObserverError();

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <div className="w-full h-full">
      <App />
    </div>,
  );
} else {
  console.error('Root element not found');
}
